import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import DropdownList from 'react-widgets/lib/DropdownList';

const propTypes = exact({
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
});

const data = [
  { name: 'no response', value: null },
  { name: '1', value: 1 },
  { name: '2', value: 2 },
  { name: '3', value: 3 },
  { name: '4', value: 4 },
  { name: '5', value: 5 },
  { name: '6', value: 6 },
  { name: '7', value: 7 },
  { name: '8', value: 8 },
  { name: '9', value: 9 },
  { name: '10', value: 10 },
];

const CustomerFeedbackList = (props) => {
  const {
    value,
    onChange,
  } = props;

  return (
    <div>
      <DropdownList
        value={value}
        data={data}
        onChange={onChange}
        valueField="value"
        textField="name"
      />
    </div>
  );
};


CustomerFeedbackList.propTypes = propTypes;


export default CustomerFeedbackList;
